import { getRequest, postRequest } from './request'

// 地区列表
const village = data => {
   return postRequest('/village/index', data)
}
// 三务
const getArticle = data => {
   return postRequest('/article/index', data)
}
// 三务文章详情
const getArticleInfo = data => {
   return postRequest('/article/info', data)
}
// 添加阅读次数
const addView = data => {
   return postRequest('/article/addView', data)
}
// 图片上传
const uploadImages = data => {
   return postRequest('/common/uploadImages', data)
}
// 举报
const report = data => {
   return postRequest('/report/index', data)
}
export {
   village,
   getArticle,
   getArticleInfo,
   addView,
   uploadImages,
   report
}


// WEBPACK FOOTER //
// ./src/api/apiData.js